<script>
import feather from 'feather-icons';

export default {
	name: 'Home',
	data: () => {
		return {
			theme: '',
		};
	},
	created() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
	mounted() {
		feather.replace();
		this.theme = localStorage.getItem('theme') || 'light';
	},
	updated() {
		feather.replace();
	},
	methods: {},
};
</script>

<template>
	<section id="bannersec" class="flex flex-row items-end">
		<div class="w-full md:w-1/3 mt-12 ml-12">
			<div class="md:justify-start mb-10 sm:mt-20 justify-center flex">
				<router-link to="/botoniel"
					class="font-bold items-left px-14 py-4 rounded-full shadow-lg hover:shadow-xl bg-[#0093B9] hover:bg-[#5271FF] focus:ring-1 focus:ring-indigo-900 text-white text-xl duration-300"
					aria-label="BotOniel">
					<button type="button">Access BotOniel Here</button>
				</router-link>
			</div>
			<h1 class="font-bold text-3xl md:text-3xl xl:text-4xl text-center md:text-left text-white md:text-primary-dark mb-10 mt-10">
				BotOniel: Jokes Generator
			</h1>
			<p
				class="font-general-medium mt-2 text-2xl md:text-3xl xl:text-4xl text-center md:text-left md:text-primary-dark text-white mt-10">
				“A good laugh overcomes more difficulties and dissipates more dark clouds than any other one thing”
			</p>
			<p
				class="font-bold xl:mt-2 text-lg sm:text-xl xl:text-xl text-center md:text-left leading-none md:text-primary-dark text-white mb-28 mt-5">
				Laura Ingalls Wilder
			</p>
		</div>
	</section>
</template>

<style scoped>
#bannersec {
	background: url(@/assets/images/background-images/oniel-2.jpg);
	width: 100vw;
	height: 100vh;
	/* Adjust the height as needed */
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
}

/* Media query untuk tampilan mobile */
@media (max-width: 640px) {

	section {
		background-position: right 300px top 0px;
		/* Mengubah posisi background ke kanan pada tampilan mobile */
	}
}
</style>

<!--
<a href="http://ssk.jkt48.com/2024/id" target="_blank"
				class="font-bold items-left px-8 py-6 rounded-full shadow-lg hover:shadow-xl bg-[#0093B9] hover:bg-[#5271FF] focus:ring-1 focus:ring-indigo-900 text-white text-xl duration-300"
				aria-label="BotOniel">
				<button type="button">1st Pre-result: 8.270 Vote (12th Rank)</button>
			</a>
			<p
				class="font-bold mt-8 text-lg sm:text-xl xl:text-2xl text-center md:text-left leading-none text-white mt-10 mb-10">
				“Maju Oshimennya, Bahagia Pendukungnya!”
			</p>
-->
